import { ChildModel, ModelBase } from 'store/model-base';

import { DataPlan } from './data-plan';
import { AccountEligibilityStatus } from 'my-account/constants';

export class AccountPlanEligibility extends ModelBase {
    public static storeName: string = 'accountPlanEligibility';
    public static idAttribute: string = 'lineKey';

    public plans: DataPlan[];
    public accountEligiblityStatus: AccountEligibilityStatus;

    public eligiblePlan: DataPlan;
    public isEligible: boolean;
    public isInEligible: boolean;
    public requiresUpgrade: boolean;

    public static create<T extends ModelBase>(response: ApiResponse): T {
        const toReturn: AccountPlanEligibility = super.create<AccountPlanEligibility>(response);
        toReturn.eligiblePlan = toReturn.plans.find((plan: DataPlan) => plan.isEligible || plan.requiresUpgrade);
        toReturn.isEligible = Boolean(toReturn.eligiblePlan);
        toReturn.isInEligible = !toReturn.isEligible;
        toReturn.requiresUpgrade = toReturn.eligiblePlan && toReturn.eligiblePlan.requiresUpgrade;

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'plans',
            model: DataPlan
        }];
    }
}
